// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab_tab__1sqPq","disabled":"Tab_disabled__2Qx2J","selected":"Tab_selected__nKhKb"};